/* Automatic location ask, on any page.

   If the visitor has no saved pincode yet, ask the browser for their location once, turn it into
   a pincode, and store it. A "no" is remembered and never asked again. If a pincode is already
   saved, nothing is asked. */
(function () {
  if (window.__givaUseCurrentLocation) return;
  window.__givaUseCurrentLocation = true;

  var ENDPOINT = 'https://api.givadiva.co/v2/maps/getPincodeFromCoords';
  var GEO_OPTIONS = { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 };
  var DENIED_KEY = 'ulcLocationDenied';
  var AUTO_ASK_DELAY_MS = 300;

  function storageGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  function storageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* storage blocked: ignore */ }
  }

  function fetchPincode(lat, lng) {
    var url = ENDPOINT + '?lat=' + encodeURIComponent(lat) + '&lng=' + encodeURIComponent(lng);
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var pin = res && res.success && res.data && res.data.pincode;
        return /^\d{6}$/.test(String(pin || '')) ? String(pin) : null;
      });
  }

  function hasSavedPincode() {
    return !!(storageGet('sddPincode') || storageGet('cartPincode'));
  }

  // Saves the detected pincode and runs it through the site's normal pincode handling: the header
  // input + checkSameDayDelivery() (header text, delivery info), and on the PDP the pincode form.
  function storeAndApply(pin) {
    storageSet('sddPincode', pin);

    var headerInput = document.querySelector('#pincode_input');
    if (headerInput) {
      headerInput.value = pin;
      headerInput.dispatchEvent(new Event('input', { bubbles: true }));
      if (typeof window.checkSameDayDelivery === 'function') window.checkSameDayDelivery();
    }

    var pdpInput = document.querySelector('#pincode__input');
    var pdpCheck = document.querySelector('.pincode_check');
    if (pdpInput && pdpCheck) {
      pdpInput.value = pin;
      pdpCheck.click();
    }
  }

  function askForLocation() {
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        fetchPincode(pos.coords.latitude, pos.coords.longitude)
          .then(function (pin) { if (pin) storeAndApply(pin); })
          .catch(function () { /* no pincode this time: we'll ask again on a later visit */ });
      },
      function (err) {
        // Refused (or the prompt was dismissed): remember it and never ask again.
        // Any other failure (timeout, position unavailable) is not a "no", so we may ask again.
        if (err && err.code === 1) storageSet(DENIED_KEY, '1');
      },
      GEO_OPTIONS
    );
  }

  function maybeAskAutomatically() {
    if (!navigator.geolocation) return;
    if (hasSavedPincode()) return;
    if (storageGet(DENIED_KEY) === '1') return;

    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'geolocation' }).then(
        function (status) {
          if (status.state === 'denied') {
            storageSet(DENIED_KEY, '1');
            return;
          }
          askForLocation();
        },
        askForLocation
      );
    } else {
      askForLocation();
    }
  }

  function scheduleAutomaticAsk() {
    // Not inside the theme editor or an embedded frame.
    if (window.top !== window.self) return;
    if (window.Shopify && window.Shopify.designMode) return;
    setTimeout(maybeAskAutomatically, AUTO_ASK_DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleAutomaticAsk);
  } else {
    // DOMContentLoaded has already fired (interactive or complete).
    scheduleAutomaticAsk();
  }
})();
